import React from 'react';
import ReactDOM from 'react-dom';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/scss/base.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
